import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Input, Menu, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateComponentSettings } from '../../redux/board/reducer';
import { setIsContentChange } from '../../redux/stateManager/reducer';
import { eventBus, GROUP, ITEXT, TEXT } from '../../utils';
import ColorPicker from '../ColorPicker';
import './styles.scss';

const SHADOW_POSITION = ['none', 'all', 'top', 'right', 'bottom', 'left', 'custom'];
const SHADOW = {
  none: 'none',
  all: 'all',
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  custom: 'custom',
};
const SHADOW_BLUR = 4;
const SHADOW_OFFSET = 3;
const SHADOW_COLOR = '#878D99';
const BLUR_ALL = 12;
let timeout = null;
export default () => {
  const dispatch = useDispatch();
  const [position, setPosition] = useState(SHADOW_POSITION[0]);
  const activeType = useSelector((state) => state.board.activeType);
  const componentSettings = useSelector((state) => state.board.componentSettings);
  const initialShadow = {
    offsetX: 0,
    offsetY: 0,
    blur: 5,
    color: '#000',
  };
  const [shadowPos, setShadowPos] = useState(initialShadow);
  const [state, _setState] = useState({});
  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));

  const shouldRender = () => {
    const activeObj = window.canvas.getActiveObject();
    if (!activeObj) return false;
    const isText = [TEXT, ITEXT].includes(activeType);
    const isGroup = [GROUP].includes(activeType);
    if (isGroup && activeObj.colorSetting) {
      return true;
    }
    if (isText || isGroup) {
      return false;
    }

    return true;
  };

  const onClick = (e) => {
    const pos = SHADOW_POSITION[e.key];
    let s = null;
    setPosition(pos);
    switch (pos) {
      case SHADOW.top:
        s = {
          color: SHADOW_COLOR,
          blur: SHADOW_BLUR,
          offsetY: -SHADOW_OFFSET,
          offsetX: 0,
          position: 'top',
        };
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: s }));
        return;
      case SHADOW.bottom:
        s = {
          color: SHADOW_COLOR,
          blur: SHADOW_BLUR,
          offsetY: SHADOW_OFFSET,
          offsetX: 0,
          position: 'bottom',
        };
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: s }));
        return;
      case SHADOW.right:
        s = {
          color: SHADOW_COLOR,
          blur: SHADOW_BLUR,
          offsetY: 0,
          offsetX: SHADOW_OFFSET,
          position: 'right',
        };
        dispatch(updateComponentSettings({ ...state, shadow: s }));
        return;
      case SHADOW.left:
        s = {
          color: SHADOW_COLOR,
          blur: SHADOW_BLUR,
          offsetY: 0,
          offsetX: -SHADOW_OFFSET,
          position: 'left',
        };
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: s }));
        return;
      case SHADOW.all:
        s = {
          color: SHADOW_COLOR,
          blur: BLUR_ALL,
          offsetY: 0,
          offsetX: 0,
          position: 'top',
        };
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: s }));
        return;
      case SHADOW.custom:
        setShadowPos(initialShadow);
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: initialShadow }));
        break;
      case SHADOW.none:
        setShadowPos({});
        eventBus.emit('save-state-and-progress');
        dispatch(setIsContentChange(true));
        dispatch(updateComponentSettings({ ...state, shadow: {} }));
        break;
      default:
        break;
    }
  };
  const menu = (
    <Menu onClick={onClick}>
      {SHADOW_POSITION.map((f, index) => (
        <Menu.Item key={index} style={{ textTransform: 'capitalize' }}>
          {f}
        </Menu.Item>
      ))}
    </Menu>
  );
  const getPosition = (data) => {
    if (!data || Object.keys(data).length === 0) return SHADOW.none;
    const { offsetX, offsetY, blur, color } = data;

    if (offsetY === -SHADOW_OFFSET && offsetX === 0 && blur === SHADOW_BLUR && color === SHADOW_COLOR) {
      return SHADOW.top;
    }
    if (offsetY === SHADOW_OFFSET && offsetX === 0 && blur === SHADOW_BLUR && color === SHADOW_COLOR) {
      return SHADOW.bottom;
    }
    if (offsetX === -SHADOW_OFFSET && offsetY === 0 && blur === SHADOW_BLUR && color === SHADOW_COLOR) {
      return SHADOW.left;
    }
    if (offsetX === SHADOW_OFFSET && offsetY === 0 && blur === SHADOW_BLUR && color === SHADOW_COLOR) {
      return SHADOW.right;
    }
    if (offsetX === 0 && offsetY === 0 && blur === BLUR_ALL) {
      return SHADOW.all;
    }
    return SHADOW.custom;
  };

  const onChange = (e, key) => {
    clearTimeout(timeout);
    const newO = { ...shadowPos, [key]: parseInt(e.target.value || 0) };
    setShadowPos(newO);
    timeout = setTimeout(() => {
      eventBus.emit('save-state-and-progress');
      dispatch(setIsContentChange(true));
      dispatch(updateComponentSettings({ ...state, shadow: newO }));
    }, 200);
  };
  const onColorChange = (e) => {
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, shadow: { ...shadowPos, color: e } }));
  };
  useEffect(() => {
    if (componentSettings) {
      const { shadow } = componentSettings;
      setState(componentSettings);
      setPosition(getPosition(shadow));
      setShadowPos(shadow);
    } else {
      setPosition(SHADOW.none);
    }
  }, [componentSettings]);
  return shouldRender() ? (
    <div className="mo__shadow-settings">
      <div className="shadow">
        <span className="title">Position</span>
        <Dropdown overlay={menu} trigger={['click']}>
          <Button type="text" style={{ padding: '5px', textTransform: 'capitalize' }}>
            {position}
            {''}
            <DownOutlined style={{ fontSize: '12px' }} />
          </Button>
        </Dropdown>
      </div>
      {position === SHADOW.custom && (
        <div className="custom-shadow">
          <div className="custom-row">
            <span>Vert Offset</span>
            <Tooltip title="Vertical Offset">
              <Input
                className="custom-input"
                title="Vertical Offset"
                type="number"
                value={shadowPos.offsetY || 0}
                onChange={(e) => {
                  onChange(e, 'offsetY');
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          </div>
          <div className="custom-row">
            <span>Horz Offset</span>
            <Tooltip title="Horizontal Offset">
              <Input
                className="custom-input"
                title="Horizontal Offset"
                type="number"
                value={shadowPos.offsetX || 0}
                onChange={(e) => {
                  onChange(e, 'offsetX');
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          </div>
          <div className="custom-row">
            <span>Blur</span>
            <Tooltip title="Blur">
              <Input
                className="custom-input"
                title="Blur"
                type="number"
                value={shadowPos.blur || 0}
                onChange={(e) => {
                  onChange(e, 'blur');
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          </div>
          <div className="custom-row">
            <span>Color</span>
            <Tooltip title="Color">
              <ColorPicker
                onChange={onColorChange}
                type="stroke"
                color={shadowPos.color || state.fill}
                place="settings"
              />
            </Tooltip>
          </div>
        </div>
      )}
      <div />
    </div>
  ) : (
    <div />
  );
};
